class NewrelicHelper {
  constructor ({ newrelic, isTest, appVersion }) {
    this.$newrelic = isTest
      ? null
      : newrelic

    if (this.$newrelic) {
      this.$newrelic.addRelease('claro-controle-auto-servico', appVersion)
    }
  }

  notifyError (...args) {
    if (!this.$newrelic) {
      console.warn( // eslint-disable-line
        '$newrelic.noticeError',
        ...args
      )
      return
    }

    this.$newrelic.noticeError(...args)
  }

  addToTrace (data) {
    if (!this.$newrelic) {
      console.warn( // eslint-disable-line
        '$newrelic.addToTrace',
        data
      )
      return
    }

    this.$newrelic.addToTrace(data)
  }

  error (...args) {
    if (args.length > 1) {
      return this.notifyError(...args)
    }

    const err = args[0]
    const metaData = err.metaData || {}

    return this.notifyError(err, metaData)
  }
}

export { NewrelicHelper }
